import { render, staticRenderFns } from "./ExtraworkListDetails.vue?vue&type=template&id=db250624&scoped=true"
import script from "./ExtraworkListDetails.vue?vue&type=script&lang=js"
export * from "./ExtraworkListDetails.vue?vue&type=script&lang=js"
import style0 from "./ExtraworkListDetails.vue?vue&type=style&index=0&id=db250624&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db250624",
  null
  
)

export default component.exports